module.exports = __webpack_public_path__ + "static/media/Submarine.9a23e8f3.svg";